const links = {
  detailedInformationLink:
    'https://cdn.bitpanda.com/media/documents/securities/de-kundeninformationsdokument.pdf',
  cookiePolicy:
    'https://cdn.bitpanda.com/terms-and-conditions/cookie-policy-bitpanda-en-1.0.1.pdf',
};

export { links };
